import { Component, inject, Input, OnInit } from '@angular/core';
import { GridDataDto } from 'src/models/ts/grid-data-dto.model';
import { GridOptionsDto } from 'src/models/ts/grid-options-dto.model';
import { CollectionType } from 'src/models/ts/collection-type.model';
import { Store } from '@ngrx/store';
import moment from 'moment/moment';
import { UserSettingsDto } from '../../../../models/ts/user-settings-dto.model';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';

@Component({
  selector: 'bizz-report-instance-field-value-history-grid',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  templateUrl: './report-instance-field-value-history-grid.component.html',
  styleUrl: './report-instance-field-value-history-grid.component.scss'
})
export class ReportInstanceFieldValueHistoryGridComponent implements OnInit{
  @Input() public auditData: GridDataDto;
  @Input() public auditGridOptions: GridOptionsDto;
  @Input() public collectiontype: CollectionType;
  @Input() public userSettings: UserSettingsDto;
  public showVersionColumn: boolean;
  public store$ = inject(Store);

  public ngOnInit(): void {
    this.showVersionColumn = this.collectiontype == CollectionType.ControlledDocument;
  }

  public dateWithTimezone(date: string): string {
      return moment(new Date(date), this.userSettings.TimezoneName).format(this.userSettings.DateFormatTypeString.replace('dd', 'DD'));
  }
}
